// 组件对象，大写
import navigation from './navigation.vue'
export default navigation
